import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  border-radius: 9px 0 0 9px;
  background-color: #f3f5f7;
  position: relative;
  display: inline-block;

  &:hover > div{
    display: block;
  }

  &:hover {
    border-radius: 9px 0 0 0;

    #dropdownIcon {
      transform: rotate(180deg)
    }
  }
`;

export const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #f3f5f7;
  z-index: 1;
  border-radius: 0 0 0 9px;
`;

export const DropdownIcon = styled.img`
  margin-left: 6px;
`;

export const SelectedItem= styled.div`
  display: flex;
  flex-direction: row;
  padding: 14px 25px 15px 24px;

  ${({screenClass}) => screenClass === 'xs' &&
    'padding-right: 10px;'
  }
`;

export const Item = styled.div`
  display: block;
  padding: 14px 55px 15px 24px;
  border-top: solid 1px #e7e7e7;
  cursor: pointer;

  ${({screenClass}) => screenClass === 'xs' && 
    'padding-right: 40px;'
  }
`;

export const LanguageLabel = styled.p`
  font-weight: 600;
  color: #626e75;
`;
